import React, { Component } from 'react'
import Swiper from 'react-slider-swiper'
import firebase from 'firebase'
import { find } from 'lodash'
// import moment from 'moment'
import Lines from '../Lines'
import animateScrollTo from 'animated-scroll-to'

import './styles/NewsSectionStyles.css'

const breakpoints = {
    2024: {
        slidesPerView: 3,
        spaceBetween: 0
    },
    1024: {
        slidesPerView: 2,
        spaceBetween: 30
    },
    768: {
        slidesPerView: 2,
        spaceBetween: 30
    },
    640: {
        slidesPerView: 1,
        spaceBetween: 30
    },
    320: {
        slidesPerView: 1,
        spaceBetween: 30
    }
}

class NewsSection extends Component {
    constructor(props) {
        super(props)

        this.state = {
            title: '',
            descr: '',
            news: [],
            isAllNewsVisible: false,
        }
    }

    renderItem = (item) => {
        return (
            <div className="NewsSlideWrapper"
                onClick={() => {
                    this.props.Popover.show({
                        ...item,
                        address: item.date
                    })
                }}
            >
                <div className="NewsItemDate">
                    <span className="NewsItemDateText">{item.date ? item.date : '-'}</span>
                </div>
                <div className={'NewsSlide'}>
                    <div className={'NewsItemImage'} style={{ backgroundImage: `url(${this.getPhoto(item)})` }} />
                    <div className={'NewsItemContent'}>
                        <span className="NewsItemTitle">{item.title ? item.title : '-'}</span>
                        <div className="Spacer" />
                        <div className="NewsItemTags">
                            {this._renderTags(item.tags)}
                        </div>

                    </div>
                </div>
            </div>
        )
    }

    componentDidMount() {

        const dbRef = firebase.database().ref('sections/NewsSection/')

        dbRef.on('value', this.setData)
    }

    setData = (snapshot) => {
        const data = snapshot.val()

        if (data) {
            const objects = []
            for (let key in data.news) {
                const item = data.news[key]
                if (!item.isReady && item.isVisible) {
                    objects.push(data.news[key])
                }
            }
            this.setState({
                ...data,
                news: objects,
            })
        }
    }

    getPhoto(item) {
        if (item.photo && item.photo.length) {
            const photo = find(item.photo, { isMain: true })
            if (photo) {
                return photo.thumbUrl ? photo.thumbUrl : photo.url
            } else {
                return item.photo[0].thumbUrl ? item.photo[0].thumbUrl : item.photo[0].url
            }
        } else {
            return ''
        }
    }

    _renderSlides() {
        return this.state.news.map((item, i) => {

            return (
                <div key={`NewsSlide${i}`}>
                    {this.renderItem(item)}
                </div>
            )
        })
    }

    _renderTags(tags) {
        if (!tags) {
            return null
        }
        let tagsArr = []

        for (let key in tags) {
            tagsArr.push(tags[key])
        }
        return tagsArr.map((item, i) => {
            return (
                <Tag key={`Tag${i}`} title={item.title} />
            )
        })
    }

    showAllNews = () => {
        this.setState({
            isAllNewsVisible: true
        }, () => {
            if (this.props.appRootView.refs.news) {
                animateScrollTo(this.props.appRootView.refs.news.offsetTop)
            }
        })
    }

    hideAllNews = () => {
        this.setState({
            isAllNewsVisible: false
        }, () => {
            if (this.props.appRootView.refs.news) {
                animateScrollTo(this.props.appRootView.refs.news.offsetTop)
            }
        })
    }

    goNext = () => {
        if (this.swiper) this.swiper.slideNext()
    }

    goPrev = () => {
        if (this.swiper) this.swiper.slidePrev()
    }

    renderSlider = () => {

        return (
            <div className="NewsSectionSlider">
                {(this.state.news.length > 0) ? (
                    <Swiper
                        pagination={'.noDots'}
                        paginationClickable={true}
                        nextButton={'.NewsSliderNextArrow'}
                        prevButton={'.NewsSliderPrevArrow'}
                        spaceBetween={0}
                        slidesPerView={3}
                        loop={true}
                        breakpoints={breakpoints}
                        onInit={(swiper) => {
                            this.swiper = swiper
                        }}
                    >
                        {this._renderSlides()}
                    </Swiper>
                ) : null}

                <div className="PrevArrowButton" onClick={this.goPrev} />
                <div className="NextArrowButton" onClick={this.goNext} />
            </div>
        )
    }

    renderAllNews = () => {
        return (
            <div className="AllNewsWrapper">
                {this.state.news.map((item, i) => {
                    return (
                        <div className={'AllNewsItem'} key={`AllNewsItem${i}`}>
                            {this.renderItem(item)}
                        </div>
                    )
                })}
            </div>
        )
    }

    render() {



        return (
            <div className="NewsSectionWrapper">
                <div className="NewsSectionContent">
                    <div className="ObjectSectionTitle columns is-mobile">
                        <h2 className="column is-11 is-offset-1">{this.state.title}</h2>
                    </div>
                    <div className="ObjectSectionDescription columns is-mobile">
                        <p className="column is-5 is-offset-1">{this.state.descr}</p>
                    </div>
                    {this.state.isAllNewsVisible ? this.renderAllNews() : this.renderSlider()}
                    <div className="NewsSectionMoreWrapper">
                        <div
                            className={`ShowMoreNewsButton ${this.state.isAllNewsVisible ? 'ShowLessNewsButton' : ''}`}
                            onClick={this.state.isAllNewsVisible ? this.hideAllNews : this.showAllNews}
                        >
                            {this.state.isAllNewsVisible ? 'Скрыть' : 'Все новости'}
                        </div>
                    </div>

                </div>
                <Lines opacity={1} color={'#9ccdfa'} />
            </div>
        )
    }
}

const Tag = (props) => {
    return (
        <div className="TimeLineTagWrapper">
            {props.title || 'empty'}
        </div>
    )
}

export default NewsSection


// WEBPACK FOOTER //
// ./src/Components/Sections/NewsSection.js